import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {providersImages} from "../../config/providers-images.config";
import {GamesPlaygroundService} from "../../service/games-playground/games-playground.service";

@Component({
  selector: 'app-games-list',
  templateUrl: './games-list.component.html',
  styleUrls: ['./games-list.component.scss']
})
export class GamesListComponent implements OnInit {
  providersImages = providersImages;

  constructor(private gamesPlaygroundService: GamesPlaygroundService) { }

  ngOnInit() {
  }

  getProviderSlideImg(shortName): string {
    const providerInfo = this.providersImages.find(provider => provider.shortName === shortName);
    return providerInfo.imageSlide ? providerInfo.imageSlide : providerInfo.imageTitle;
  }

  getGames() {
    return this.gamesPlaygroundService.getGames();
  }

  selectGame(shortName) {
    this.gamesPlaygroundService.updateGames.emit(shortName);
  }
}
